<template>
  <div>
    <div class="sign-up-title text-center mb-4">
      Create your team profile
    </div>
    <team-profile-form :submitting="submitting" @back="$emit('back')" @submit="onSubmit" />
  </div>
</template>

<script>
import TeamProfileForm from '@/components/forms/CreateProfile/TeamProfileForm.vue'

export default {
  name: 'TeamProfile',

  props: {
    submitting: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onSubmit(data) {
      this.$store.dispatch('signup/createTeamProfile', data)
        .then(() => this.$emit('submitted'))
    }
  },

  components: {
    TeamProfileForm
  }
}
</script>
